import React from "react";
import { useInView } from "react-intersection-observer";
import cardtop from "../Images/cardtop.png";
const Card = ({ title, description, Icon, delay }) => {
  const { ref, inView } = useInView({
    triggerOnce: false, // Trigger the animation every time the element comes into view
    threshold: 0.1, // 10% of the card is in view
  });

  return (
    <div
      ref={ref}
      className={` p-6 md:text-left lg:text-left transition-transform duration-500 ease-in-out transform hover:scale-105 hover:duration-[1s]  ${
        inView ? "scale-100 opacity-100" : "scale-75 opacity-50"
      }`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <img src={cardtop} className="rounded-t-[20px] w-full" />
      <div className="flex flex-col items-center justify-center border-2 p-6 rounded-lg border-teal-500 pb-10 bg-gradient-to-r bg-white bg-opacity-60 hover:shadow-lg   hover:shadow-teal-200">
        <div className=" flex items-center justify-center w-16 h-16  shadow-lg border border-teal-400 bg-white  rounded-full">
          <img src={Icon} alt={`${title} icon`} className="w-8 h-8 " />
        </div>
        <h3 className="mt-4 text-center text-xl font-semibold text-teal-800">{title}</h3>
        <p className="text-center text-teal-700">{description}</p>
      </div>
    </div>
  );
};

export default Card;
